import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import { Provider } from 'react-redux';
import { store } from "./state";
import { Router, Route, Switch } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import history from './services/History';

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <App>
        <Switch>
          <Route path="/" component={Dashboard} />
        </Switch>
      </App>
    </Router>
  </Provider>,
  document.getElementById('root')
);

